<template>
  <div  v-bind="$attrs">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
};
</script>

<style scoped lang="scss"></style>
